export const UI_TAGS = Object.freeze({
    TEXT_INSTRUCTION: "text_instruction",
    TEXT_INSTRUCTION_DISCARD: "text_instruction_discard",
    GENERIC_COUNTER: "generic_counter",
    MENU_BUTTON: "menu_button",
    NB_PLAYER_BUTTON: "nb_player_button",
    SELECT_TEAM_BUTTON: "select_team_button",
    CURRENT_TURN_BANNER: "current_turn_banner",
});